import * as React from 'react';
import styled from 'styled-components';
import AngleRight from '../components/AngleRight';

const LinkWrapper = styled.figcaption`
	// background-color: transparent;
`;

const Link = styled.a`
	&:hover {
		text-decoration: none;
	}
`;

const SeePost = (props: any) => (
	<LinkWrapper>
		<Link
			className='animate-right'
			href={props.url}
			title={props.title}
			target='_blank'
			rel='noopener noreferrer'
		>
			See Post<AngleRight />
		</Link>
	</LinkWrapper>
);

export default SeePost;
